const setToken = (state, {token}) => {
  state.token = token;
};

const setUser = (state, user) => {
  state.user = user;
};

const setAccess = (state, access) => {
  state.access = access;
};

const removeToken = (state) =>{
  state.token = null;
};

export default {
  setToken,
  removeToken,
  setUser,
  setAccess,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js